var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,40%,60%)",
      fillOpacity: 1
    },
    d: "M 0 3.519531 C 0 1.628906 1.589844 0.0976562 3.546875 0.0976562 L 44.453125 0.0976562 C 46.410156 0.0976562 48 1.628906 48 3.519531 L 48 44.480469 C 48 46.371094 46.410156 47.902344 44.453125 47.902344 L 3.546875 47.902344 C 1.589844 47.902344 0 46.371094 0 44.480469 Z M 0 3.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.585938 40.105469 L 14.585938 18.582031 L 7.402344 18.582031 L 7.402344 40.105469 Z M 10.996094 15.644531 C 13.5 15.644531 15.058594 13.992188 15.058594 11.925781 C 15.011719 9.8125 13.5 8.207031 11.042969 8.207031 C 8.585938 8.207031 6.980469 9.8125 6.980469 11.925781 C 6.980469 13.992188 8.539062 15.644531 10.949219 15.644531 Z M 18.5625 40.105469 L 25.746094 40.105469 L 25.746094 28.085938 C 25.746094 27.445312 25.792969 26.800781 25.980469 26.339844 C 26.5 25.054688 27.683594 23.722656 29.667969 23.722656 C 32.265625 23.722656 33.304688 25.699219 33.304688 28.59375 L 33.304688 40.105469 L 40.488281 40.105469 L 40.488281 27.765625 C 40.488281 21.152344 36.945312 18.078125 32.21875 18.078125 C 28.34375 18.078125 26.644531 20.234375 25.699219 21.703125 L 25.746094 21.703125 L 25.746094 18.582031 L 18.5625 18.582031 C 18.65625 20.601562 18.5625 40.105469 18.5625 40.105469 Z M 18.5625 40.105469 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon21);
export default __webpack_public_path__ + "static/media/linkedin-icon-2(1).9e134ecb7948fbbd9557ad4dc8160e92.svg";
export { ForwardRef as ReactComponent };